"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation } from "@packages/sdk";

import { useInvalidateCommunityQueries } from "./utils/useInvalidateCommunityQueries";

export const COMMUNITY_ADMIN_MEMBERS_DELETE_BATCH_SIZE = 100;
const urlBackendPath = "/communities/{community_id}/admin/members" as const;

export const useRequestCommunityAdminMembersDelete = ({
  id,
  ...props
}: { id: number } & Partial<
  UseOpenApiMutationOptions<typeof urlBackendPath, "DELETE">
>) => {
  const invalidateCommunityQueries = useInvalidateCommunityQueries({ id });

  return useOpenApiMutation({
    method: "DELETE",
    onSuccess: (data, variables, context) => {
      invalidateCommunityQueries();
      props.onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
